import * as Yup from 'yup'
import { z, z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const OrdersWestfieldCorpDefaultSchemas = DefaultSchemas

const OrdersWestfieldCorpDetailsCardsDataSchemas = zod.object({
  traderId: zod.number(),
  traderTransIdent: zod.string(),
})

const OrdersWestfieldCorpDetailsDataSchemas = zod.object({
  detailId: zod.string(),
  value: zod.number(),
  quantity: zod.number(),
  productName: zod.number(),
  cards: zod.array(OrdersWestfieldCorpDetailsCardsDataSchemas),
})

export const OrdersWestfieldCorpDataSchemas = zod.object({
  comments: zod.string().nullable(),
  contactId: zod.number(),
  contactFirstName: zod.string().nullable(),
  contactLastName: zod.string().nullable(),
  deliveryAddress1: zod.string().nullable(),
  deliveryAddress2: zod.string().nullable(),
  deliveryCity: zod.string().nullable(),
  deliveryCompanyName: zod.string().nullable(),
  deliveryFirstName: zod.string().nullable(),
  deliveryLastName: zod.string().nullable(),
  deliveryPostcode: zod.string().nullable(),
  deliveryState: zod.string().nullable(),
  deliverySuburb: zod.string().nullable(),
  flCorpOnline: zod.number(),
  invoiceDate: zod.string().nullable(),
  orderConfirmDate: zod.string().nullable(),
  orderId: zod.number(),
  orderStatusId: zod.number(),
  orderStatusName: zod.string(),
  paymentReason: zod.string().nullable(),
  paymentTypeId: zod.number(),
  paymentTypeName: zod.string(),
  prmCode: zod.string().nullable(),
  purchaseOrder: zod.string().nullable(),
  quoteNotes: zod.string().nullable(),
  referenceNumber: zod.number().nullable(),
  totalGST: zod.number(),
  totalTopupAmount: zod.number(),
  traderId: zod.number(),
  traderName: zod.string(),
  trackingNumber: zod.number().nullable(),
  trackingStatus: zod.string().nullable(),
})

export const OrdersWestfieldCorpAPISchemas =
  OrdersWestfieldCorpDefaultSchemas.merge(
    zod.object({
      data: zod.array(OrdersWestfieldCorpDataSchemas),
    })
  )

export const OrdersWestfieldCorpFetchParamsSchemas = zod.object({
  enrolmentTraderId: zod.number().optional().nullable(),
  traderId: zod.number().optional().nullable(),
  orderId: zod.number().optional().nullable(),
  traderName: zod.string().optional().nullable(),
  startDate: zod.string().optional(),
  endDate: zod.string().optional(),
  orderStatusId: zod.number().optional().nullable(),
})

export const OrdersWestfieldCorpUpdateParamsSchemas = zod.object({
  traderId: zod.number(),
  noteId: zod.number(),
  noteTypeId: zod.string(),
  priorityLevel: zod.string(),
  noteDescription: zod.string(),
  creationDate: zod.string(),
  sourceName: zod.string(),
})
